import React from 'react';
import { ChatBubbleLeftIcon } from '@heroicons/react/24/outline';
import LikeButton from './LikeButton';

/**
 * Compact mobile action bar for individual replies
 * Displays like and reply actions with smaller, subtle styling
 */
const MobileReplyActions = ({
  likeCount = 0,
  isLiked = false,
  targetId,
  authorId,
  onLike,
  onReply,
  size = 'sm'
}) => {
  return (
    <div className="flex items-center space-x-4 text-xs text-gray-500 dark:text-gray-400">
      {/* Like button - smaller and more subtle */}
      <LikeButton
        targetType="reply"
        targetId={targetId}
        initialLikeCount={likeCount}
        authorId={authorId}
        onLikeUpdate={onLike}
        size="sm"
        showCount={true}
        className="border-none bg-transparent hover:bg-gray-50 dark:hover:bg-gray-800 px-2 py-1"
      />

      {/* Reply button */}
      {onReply && (
        <button
          onClick={onReply}
          className="flex items-center space-x-1 hover:text-purple-600 dark:hover:text-purple-400 transition-colors duration-200 min-h-[44px] min-w-[44px] px-3 py-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-800 active:scale-95 active:bg-gray-100 dark:active:bg-gray-700"
          style={{ touchAction: 'manipulation' }}
        >
          <ChatBubbleLeftIcon className="w-4 h-4" />
          <span className="font-medium">Reply</span>
        </button>
      )}
    </div>
  );
};

export default MobileReplyActions;